import * as React from 'react'

const SvgAdminTutorsIcon = ({ stroke }) => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.00002 21.6182C3.6026 21.8008 4.41649 21.8008 5.8 21.8008H16.2C17.5835 21.8008 18.3974 21.8008 19 21.6182M3.00002 21.6182C2.87082 21.5791 2.75133 21.5315 2.63803 21.4738C2.07354 21.1862 1.6146 20.7272 1.32698 20.1628C1 19.521 1 18.6809 1 17.0008V6.60078C1 4.92062 1 4.08055 1.32698 3.43881C1.6146 2.87432 2.07354 2.41538 2.63803 2.12776C3.27976 1.80078 4.11984 1.80078 5.8 1.80078H16.2C17.8802 1.80078 18.7202 1.80078 19.362 2.12776C19.9265 2.41538 20.3854 2.87432 20.673 3.43881C21 4.08055 21 4.92062 21 6.60078V17.0008C21 18.6809 21 19.521 20.673 20.1628C20.3854 20.7272 19.9265 21.1862 19.362 21.4738C19.2487 21.5315 19.1292 21.5791 19 21.6182M3.00002 21.6182C3.00035 20.8089 3.00521 20.3806 3.07686 20.0204C3.39249 18.4337 4.63288 17.1933 6.21964 16.8776C6.60603 16.8008 7.07069 16.8008 8 16.8008H14C14.9293 16.8008 15.394 16.8008 15.7804 16.8776C17.3671 17.1933 18.6075 18.4337 18.9231 20.0204C18.9948 20.3806 18.9996 20.8089 19 21.6182M15 9.30078C15 11.5099 13.2091 13.3008 11 13.3008C8.79086 13.3008 7 11.5099 7 9.30078C7 7.09164 8.79086 5.30078 11 5.30078C13.2091 5.30078 15 7.09164 15 9.30078Z"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAdminTutorsIcon
